// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.text-end[data-v-a91f8024]{\r\n    text-align: end;\n}\n.justify-center[data-v-a91f8024]{\r\njustify-content: end !important;\r\ndisplay:flex\n}\n.padding-left-nill[data-v-a91f8024]{\r\n    padding:0 !important;\n}\r\n", ""]);
// Exports
module.exports = exports;
